@use "../../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../../styles/Colors.scss" as Colors;

.DiffCount {
	font-size: Constants.$val-fontSizeRegular;
	line-height: Constants.$val-lineHeightRegular;
	font-weight: 500;
	cursor: default;

	&.added, &.removed {
		margin-right: Constants.$val-spacing-s;
	}

	&.added {
		color: Colors.$col-env-testing-bg;
	}

	&.removed {
		color: Colors.$col-canceledRed;
	}
}

.tooltipMessage {
	text-align: center;
}
